/**
 * Check whether search string is in one of the formats used by Google Maps
 * https://support.google.com/maps/answer/18539
 * @param {*} search
 */

function asCoordinates(search) {
  const tests = [asDMS, asDMM, asDD];
  let result;
  tests.some(func => {
    result = func(search);
    return result;
  });
  return result;
}

export default asCoordinates;

// Degrees, minutes, and seconds (DMS): 41°24'12.2"N 2°10'26.5"E
export function asDMS(search) {
  const parts = search.split(/ +/);
  if (parts.length !== 2) {
    return null;
  }
  const result = parts
    .map(findMatch(/^(\d+)°(\d+)'((\d+(\.\d+)?)")?([NESW])$/))
    .map(parseMatchDMS);
  return checkReturn(result);
}

function parseMatchDMS(match, idx) {
  if (!match) {
    return null;
  }
  const signs = [{ N: 1, S: -1 }, { E: 1, W: -1 }];
  const sign = signs[idx] && signs[idx][match[6]];
  if (!sign) {
    return null;
  }
  const result =
    Number(match[1]) + Number(match[2]) / 60 + (Number(match[4]) || 0) / 3600;
  return result * sign;
}

// Degrees and decimal minutes (DMM): 41 24.2028, 2 10.4418
export function asDMM(search) {
  const parts = search.split(/, */);
  if (parts.length !== 2) {
    return null;
  }
  const result = parts
    .map(findMatch(/^([+-]?)(\d+)( (\d+(\.\d+)?))?$/))
    .map(parseMatchDMM);
  return checkReturn(result);
}

function parseMatchDMM(match) {
  if (!match) {
    return null;
  }
  const sign = match[1] === '-' ? -1 : 1;
  const deg = Number(match[2]);
  const min = Number(match[3] || 0);
  return sign * (deg + min / 60);
}

// Decimal degrees (DD): 41.40338, 2.17403
export function asDD(search) {
  const parts = search.split(/, */);
  if (parts.length !== 2) {
    return null;
  }
  const result = parts
    .map(findMatch(/^[+-]?\d+(\.\d+)?$/))
    .map(match => match && Number(match.input));
  return checkReturn(result);
}

function findMatch(re) {
  return str => str.match(re);
}

function checkReturn(nums) {
  if (nums.some(num => typeof num !== 'number')) {
    return null;
  }
  const [lat, lng] = nums;
  return { lat, lng };
}
